import { TabContext, TabList } from '@mui/lab';
import { Grid, Tab } from '@mui/material';
import { styles } from './styles';
import { ActivityFeedContentEnum } from 'redux-store/slices/side-panel-slice';
import { useMemo } from 'react';
import { ITabsContent } from './types';

const StyledTab = ({ label, value, onClick, ...props }) => (
  <Tab
    iconPosition="start"
    label={label}
    value={value}
    onClick={onClick}
    {...props}
    sx={styles.tab}
  />
);

export const ActivityFeedTabs = ({ value, onChange }) => {
  const tabsContent: ITabsContent[] = useMemo(
    () => [
      {
        value: ActivityFeedContentEnum.FEED,
        label: ActivityFeedContentEnum.FEED,
        onClick: () => {
          onChange(ActivityFeedContentEnum.FEED);
        },
      },
      {
        value: ActivityFeedContentEnum.MEDIA,
        label: ActivityFeedContentEnum.MEDIA,
        onClick: () => {
          onChange(ActivityFeedContentEnum.MEDIA);
        },
      },
    ],
    [onChange]
  );

  return (
    <TabContext value={value}>
      <Grid sx={{ width: '100%', height: '100%' }}>
        <TabList
          sx={styles.tablist}
          TabIndicatorProps={{
            sx: styles.tabIndicator,
          }}
        >
          {tabsContent.map((item) => (
            <StyledTab key={item.value} {...item} />
          ))}
        </TabList>
      </Grid>
    </TabContext>
  );
};
